
const modalSplit = [
  {name:'Cars / Private', value: 12 },
  {name:'Cars / Commercial', value: 12 },
  {name:'Auto rickshaws / Commercial', value: 12 },
  {name:'2 wheelers / Private', value: 12 },
  {name:'2 wheelers / Commercial', value: 12 },
  {name:'Buses / Public', value: 12 },
  {name:'Metro / Public', value: 12 },
];

// Output Variables
const PROJECTIONS = [
  {
    projectionYear: 2035,
    population: 2000000,
    gdp: 100000,

    // Environmental Variables
    modalSplit: modalSplit,
    pm25Emissions: 1000,
    co2Emissions: 2000,
    vehicleDistanceTraveled: 200,
    passengerDistanceTraveled: 100,
    goals: null
  },
  {
    projectionYear: 2035,
    population: 1500000,
    gdp: 100000,

    // Environmental Variables
    modalSplit: modalSplit,
    pm25Emissions: 1000,
    co2Emissions: 2000,
    vehicleDistanceTraveled: 200,
    passengerDistanceTraveled: 100,
    goals: {
      nonMotorizedTransit: {
        name: 'non-motorized transit',
        value: 1,
      },
      publicTransit: {
        name: 'public transit',
        value: 1,
      },
      sharedMobility: {
        name: 'shared mobility',
        value: 1,
      }
    }
  },
]

export default PROJECTIONS;



// WEBPACK FOOTER //
// ./src/data/sample-projections.js